import React from 'react';
import { List, Datagrid, TextField, useListContext } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';

import AdjustmentFilterBar from './AdjustmentFilterBar';
import useSupplyStyles from '../controls/SupplyStyles';
import ErrorBoundary from '../ErrorBoundary';

const TYPE_LABEL = {
    RECEIVED: 'Received',
    QA_APPROVE: 'QA Approve',
    QA_REJECT: 'QA Reject',
    RELEASE: 'Release',
    CONSUMED: 'Consumed',
    SUBLOT_OPEN: 'Sublot Open',
    SUBLOT_CLOSE: 'Sublot Close',
    SUBLOT_CONSUME: 'Sublot Usage',
    HOLD_APPLY: 'Hold Applied',
    HOLD_RELEASE: 'Hold Released',
    TRANSFER_OUT: 'Transfer Out',
    TRANSFER_CONFIRM: 'Transfer Confirmed',
    EXPIRED: 'Expired',
    CORRECTION: 'Correction',
};

const FoundHeader = () => {
    const classes = useSupplyStyles();
    const { total } = useListContext();
    return (
        <Typography className={classes.sectionTitle}>
            <span style={{marginLeft: 18 }}>{total || 0} adjustment{total === 1 ? '' : 's'} found.</span>
        </Typography>
    );
};

const DateTimeField = ({ record }) =>
    record ? <span>{moment(record.adj_datetime).format('MM/DD/YYYY HH:mm')}</span> : null;
DateTimeField.defaultProps = { label: 'Date/Time', source: 'adj_datetime' };

const TypeField = ({ record }) =>
    record ? <span>{TYPE_LABEL[record.adj_type] || record.adj_type}</span> : null;
TypeField.defaultProps = { label: 'Adjustment Type', source: 'adj_type' };

/** Signed delta - blank when zero, so the movement stands out. */
const DeltaField = ({ record, source }) => {
    const classes = useSupplyStyles();
    if (!record) { return null; }
    const value = record[source];
    if (!value) { return <span>0</span>; }
    return (
        <span className={value > 0 ? classes.positive : classes.negative}>
            {value > 0 ? `+${value}` : value}
        </span>
    );
};

const AdjustmentContent = props => (
    <React.Fragment>
        <AdjustmentFilterBar />
        <FoundHeader />
        <Datagrid {...props}>
            <DateTimeField />
            <TypeField />
            <DeltaField source="d_qa_pending" label="QA Pending" />
            <DeltaField source="d_reserve" label="Reserve" />
            <DeltaField source="d_release" label="Release" />
            <DeltaField source="d_rel_sublot" label="Release Sublot" />
            <DeltaField source="d_hold" label="Hold" />
            <DeltaField source="d_transfer" label="Transfer" />
            <TextField source="lot_no" label="Lot #" />
            <TextField source="supply_type" label="Supply Type" />
            <TextField source="reason" label="Reason" />
            <TextField source="user_name" label="User" />
        </Datagrid>
    </React.Fragment>
);

// No `aside` here: the filter is a horizontal strip at the top of the
// results (see AdjustmentContent) rather than a left-hand card.
const AdjustmentList = props => (
    <ErrorBoundary>
        <List
            {...props}
            title="Adjustment History"
            perPage={25}
            sort={{ field: 'adj_datetime', order: 'ASC' }}
            bulkActionButtons={false}
            empty={false}
            exporter={false}
        >
            <AdjustmentContent />
        </List>
    </ErrorBoundary>
);

export default AdjustmentList;
